import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    fetchStoryboard,
    saveStoryboardSettings,
    downloadStoryboard,
    pdfDownloaded,
    resetPdf
} from "./ducks/actions";
import Storyboard from "./storyboard";

const StoryboardContainer = (props) => {
    const filmId = props.match.params.filmId;
    const { fetchStoryboard, scenes, shotsByScene, loading, saveStoryboardSettings, settings, progress, download, downloadStoryboard, pdfDownloaded, resetPdf } = props;

    useEffect(() => {
        fetchStoryboard(filmId);
    }, [filmId, fetchStoryboard]);

    return (
        <Storyboard
            scenes={scenes}
            shotsByScene={shotsByScene}
            loadingShots={loading}
            filmId={filmId}
            settings={settings}
            saveSettings={(s) => saveStoryboardSettings(filmId, s)}
            progress={progress}
            pdfDownloaded={pdfDownloaded}
            resetPdf={resetPdf}
            download={download}
            downloadFile={(settings) => downloadStoryboard(filmId, settings)}
        />
    );
};

function mapStateToProps(state) {
    return {
        scenes: state.scenesState.storyboardState.scenes,
        loading: state.scenesState.storyboardState.loading,
        settings: state.scenesState.storyboardState.settings,
        progress: state.scenesState.storyboardState.progress,
        download: state.scenesState.storyboardState.download
    };
}

export default connect(mapStateToProps, { fetchStoryboard, saveStoryboardSettings, downloadStoryboard, pdfDownloaded, resetPdf })(StoryboardContainer);
